import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { QuickAnswer } from '../types/interfaces/quick_answer.interface';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuickAnswerService {
  private http = inject(HttpClient);


  getQAns(id: number){
    return this.http.get<QuickAnswer>(`${environment.apiHost}/quickanswer/${id}`, {
      withCredentials: true,
    });
  }

  getAllQAns(){
    return this.http.get<QuickAnswer[]>(`${environment.apiHost}/quickanswer`, {
      withCredentials: true,
    });
  }

  createQAns(quickAnswer: QuickAnswer): Observable<QuickAnswer> {
    return this.http.post<QuickAnswer>(`${environment.apiHost}/quickanswer`, quickAnswer, {
      withCredentials: true,
    });
  }

  updateQAns(quickAnswer: QuickAnswer): Observable<QuickAnswer> {
    return this.http.put<QuickAnswer>(
      `${environment.apiHost}/quickanswer/${quickAnswer.id}`,
      quickAnswer,
      {
        withCredentials: true,
      }
    );
  }

  deleteQAns(id: number): Observable<QuickAnswer> {
    return this.http.delete<QuickAnswer>(`${environment.apiHost}/quickanswer/${id}`, {
      withCredentials: true,
    });
  }
}
